import { render, staticRenderFns } from "./DailyHistoryFull.vue?vue&type=template&id=d56c28ec&"
import script from "./DailyHistoryFull.vue?vue&type=script&lang=js&"
export * from "./DailyHistoryFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports